import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link, useLocation } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

function Header() {
  const location = useLocation(); // once ready it returns the 'window.location' object
  const [url, setUrl] = useState(null);
  useEffect(() => {
    setUrl(location.pathname);
  }, [location]);
  return (
   
    <Navbar collapseOnSelect expand="lg" className='nav-bar' variant="dark" sticky="top" >
      <Container>
        <Navbar.Brand href="/"><h1>Levina</h1></Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
          <Nav.Link href="/" className={"underline" + (url === "/" ?" active" : "")}>Home</Nav.Link>
          <Nav.Link href="/services" className={"underline" + (url === "/services" ?" active" : "")}>Services</Nav.Link>
            <Nav.Link href="/career" className={"underline" + (url === "/career" ?" active" : "")}>Career</Nav.Link>
            <Nav.Link href="/contact" className={"underline" + (url === "/contact" ?" active" : "")}>Contact Us</Nav.Link>
       
          </Nav>
          {/* <Nav>
            <Nav.Link href="#deets">More deets</Nav.Link>
            <Nav.Link eventKey={2} href="#memes">
              Dank memes
            </Nav.Link>
          </Nav> */}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  
  );
}

export default Header;